<div class="cardContainer" data-cy="zero-state.component">
  <div class="zeroStateContainer col-12">
    <svg *ngIf="image === 'default'" fill="none" height="175" width="206" xmlns="http://www.w3.org/2000/svg">
      <path d="M84.6 164H10.8a7 7 0 0 1-7.1-7V38a7 7 0 0 1 7-7.1h73.9V164z" fill="#F2F4FA" />
      <path d="M3.7 152v5a7 7 0 0 0 7 7h73.9v-4.8H10.8a7 7 0 0 1-7.1-7.1z" fill="#E0E5F0" />
      <path d="M7.5 157V38a7 7 0 0 1 7.1-7.1h-3.8A7 7 0 0 0 3.7 38v119a7 7 0 0 0 7 7h4a7 7 0 0 1-7.2-7z" fill="#fff" />
      <path
        d="M84.6 164H10.8a7 7 0 0 1-7.1-7V38a7 7 0 0 1 7-7.1h73.9V164z"
        stroke="#A5A8BA"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="3"
      />
      <path
        d="M195.8 164H122V31h73.8a7 7 0 0 1 7 7.1v119a7 7 0 0 1-7 7zM122 35.4H84.6v127.9c0 4.6 8.3 8.4 18.7 8.4 10.3 0 18.7-3.7 18.7-8.4V35.4z"
        fill="#F2F4FA"
      />
      <path
        d="M103.3 167c-10.4 0-18.7-3.7-18.7-8.4v4.7c0 4.6 8.3 8.4 18.7 8.4 10.3 0 18.7-3.7 18.7-8.4v-4.7c0 4.7-8.4 8.5-18.7 8.5z"
        fill="#E0E5F0"
      />
      <path d="M190.3 30.3v121.9c-36.7-13.4-72.8-5.7-87.2 8.3 14.4-14 59.4-16.7 92.5-.1V32l-5.3-1.8z" fill="#F2F4FA" />
      <path
        d="M195.8 30.9h-3.4a7 7 0 0 1 7.1 7.1v120.2a7 7 0 0 1-3.7 1H122v4.8h73.8a7 7 0 0 0 7-7V38a7 7 0 0 0-7-7.1z"
        fill="#E0E5F0"
      />
      <path
        d="M195.8 164H122V31h73.8a7 7 0 0 1 7 7.1v119a7 7 0 0 1-7 7z"
        stroke="#A5A8BA"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="3"
      />
      <path d="M103 32.4c-13.2-18-51.3-25-81.8-16.6v128.1c30.5-8.3 68.6-1.3 81.9 16.6V32.4z" fill="#fff" />
      <path
        d="M122 35.4H84.6v127.9c0 4.6 8.3 8.4 18.7 8.4 10.3 0 18.7-3.7 18.7-8.4V35.4z"
        stroke="#A5A8BA"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="3"
      />
      <path d="M15.8 152.1c36.7-13.4 72.8-5.7 87.2 8.4V32.3c-14.4-14-50.5-21.8-87.2-8.4v128.2z" fill="#fff" />
      <path
        d="M103 160.5c-12.5-17.2-48-24.3-78-17.5v5.6a106 106 0 0 1 32.3-3.3c20.1.5 37 6.6 45.8 15.2z"
        fill="#F2F4FA"
      />
      <path
        d="M15.8 152.1c36.7-13.4 72.8-5.7 87.2 8.4V32.3c-14.4-14-50.5-21.8-87.2-8.4v128.2z"
        stroke="#A5A8BA"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="3"
      />
      <path d="M103 32.4c-13.2-18-51.3-25-81.8-16.6v128.1c30.5-8.3 68.6-1.3 81.9 16.6V32.4z" fill="#fff" />
      <path d="M47.5 132.2v5.3a81.9 81.9 0 0 1 49.9 17l3.6 2.8c-5.2-7-20.5-23.1-53.5-25z" fill="#F2F4FA" />
      <path
        d="M190.3 152.1c-36.7-13.4-72.8-5.7-87.2 8.4V32.3c14.4-14 50.5-21.8 87.2-8.4v128.2z"
        fill="#F9FAFD"
        stroke="#A5A8BA"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="3"
      />
      <path
        d="M103 32.4c-13.2-18-51.3-25-81.8-16.6v128.1c30.5-8.3 68.6-1.3 81.9 16.6V32.4z"
        stroke="#A5A8BA"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="3"
      />
      <path d="M103 31.2S88 1.7 38.3 2.8V132c49.7-1.1 64.9 28.4 64.9 28.4V31.2z" fill="#fff" />
      <path d="M96.5 22.8V152c4.7 4.7 6.6 8.4 6.6 8.4V31.2s-2-3.7-6.6-8.4z" fill="#F2F4FA" />
      <path d="M103 32.4c13.4-18 51.4-25 82-16.6v128.1c-30.6-8.3-68.6-1.3-82 16.6V32.4z" fill="#fff" />
      <path
        d="M111.4 24.5a35 35 0 0 0-8.4 7.9v125a51 51 0 0 1 8.4-4.8 94 94 0 0 1 65.3-14.3V20.4c-21.9-5.9-47.6-4-65.3 4z"
        fill="#F2F4FA"
      />
      <path
        d="M103 32.4c13.4-18 51.4-25 82-16.6v128.1c-30.6-8.3-68.6-1.3-82 16.6V32.4z"
        stroke="#A5A8BA"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="3"
      />
      <path
        d="M103 31.2S88 1.7 38.3 2.8V132c49.7-1.1 64.9 28.4 64.9 28.4V31.2z"
        stroke="#A5A8BA"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="3"
      />
      <path
        d="M103.3 31.6S118.5 2 168.2 3v129.3c-49.7-1-65 28.5-65 28.5V31.6z"
        fill="#fff"
        stroke="#A5A8BA"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="3"
      />
    </svg>

    <svg *ngIf="image === 'scroll'" width="175" height="144" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M173.1 21.7c0-11.5-8.5-19.6-20-19.6-10.6 0-20.2 8.4-20.2 18.3v34.7l11-.8c1 7.3 7.1 12.9 14.6 12.9 11.7 0 14.8-10.2 14.7-20.7V21.7z"
        fill="#F2F4FA"
      />
      <path
        d="M133 25l-.2 30s16 8 19 10.3L157 67s-7.4-5-7.4-11.7v-28c0-12.3 4-22.1 15.5-21.7a21.3 21.3 0 0 0-12-3.6c-12.7.1-20.2 9.7-20.2 23z"
        fill="#E0E5F0"
      />
      <path
        d="M133.2 67.2H157c-12.7-2.2-12.8-15.8-12.8-20.7V32.2c0-7 2.3-14.4 10-14.4h-22.4l1.3 49.4z"
        fill="#F2F4FA"
      />
      <path
        d="M144.1 46.5V32.2c0-7 2.4-14.4 10-14.4h-3.7c-7.6 0-9.2 7.3-9.2 14.4v14.3c0 4.8.8 18.2 12.1 20.6h-20.2H157c-12.7-2.1-12.9-15.7-12.9-20.6z"
        fill="#fff"
      />
      <path d="M153.7 17.8c-6.3 0-10 5.7-10 12.4v11.2h20V30.2c0-6.8-3.6-12.4-10-12.4z" fill="#F2F4FA" />
      <path d="M153.7 17.8l-1.3.1c5.5.7 8.6 6 8.6 12.3v11.2h2.7V30.2c0-6.8-3.6-12.4-10-12.4z" fill="#fff" />
      <path
        d="M143.7 30.2v11.2h5.7v-9.2c0-6.1 1.8-12.4 7.1-14-.8-.2-1.8-.4-2.8-.4-6.3 0-10 5.7-10 12.4z"
        fill="#E0E5F0"
      />
      <path
        d="M156.2 17.2c-1.3-.2-2.7 0-4.1.6h2-.3c6.3 0 9.8 5.6 9.8 12.4v11.2H144v2.8h21.2c.6 0 1.2-.5 1.2-1.2V33c0-6.9-2.7-14.3-10.2-15.8z"
        fill="#E0E5F0"
      />
      <path
        d="M153.7 17.8c-6.3 0-10 5.7-10 12.4v11.2h20V30.2c0-6.8-3.6-12.4-10-12.4z"
        stroke="#A5A8BA"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <path d="M138.6 48.2V28.3c0-3.8 2.3-10.5 7.9-10.5h-14.8l.8 49.4h17.1c-6.7 0-11-8.9-11-19z" fill="#E0E5F0" />
      <path d="M127.1 67.2h31.5" stroke="#A5A8BA" stroke-width="3" stroke-miterlimit="10" stroke-linejoin="round" />
      <path
        d="M132.8 28.3c0-15.7 6-26.2 20.2-26.2H70.3c-19.2 0-28 11.2-28 28v92h50c0 11.2 9 20.3 20.3 20.3 12.2 0 20.2-9.2 20.2-23.8V28.3z"
        fill="#F9FAFD"
      />
      <path
        d="M149 2.1c-14.3 0-20.2 10.5-20.2 26.2v90.2c0 13.8-7 22.7-18.2 23.7l2 .1c12.2 0 20.2-9.1 20.2-23.8V28.3c0-15.7 6-26.2 20.2-26.2h-4z"
        fill="#fff"
      />
      <path d="M120.6 106.7h-58v3.9h58v-4zM120.6 123h-58v3.8h58V123z" fill="#E0E5F0" />
      <path d="M70.3 2.1c-15.6 0-24.3 7.4-27 19.1h90c1.5-11.7 7.7-19 19.7-19H70.3z" fill="#fff" />
      <path
        d="M173.1 21.7c0-11.5-8.5-19.6-20-19.6h-1.4a19 19 0 0 1 18.6 19.6v24.8c0 10.1-2.6 19.9-13.2 20.6l1.4.1c11.7 0 14.8-10.2 14.7-20.7V21.7z"
        fill="#fff"
      />
      <path
        d="M132.8 28.3c0-15.7 6-26.2 20.2-26.2H70.3c-19.2 0-28 11.2-28 28v92h50c0 11.2 9 20.3 20.3 20.3 12.2 0 20.2-9.2 20.2-23.8V28.3z"
        stroke="#A5A8BA"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <path
        d="M133.9 17.8h19.8c-7.1 0-9.7 6.4-9.9 13v18.5l.2 1.1v.1l.2 1.2c1.4 9.1 6.5 14.6 12.8 15.3h.4l1 .1h.1c11.7 0 14.8-10.1 14.7-20.6V21.7C173.1 10.2 164.5 2 153 2"
        stroke="#A5A8BA"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <path d="M92.4 117.3v-13.8H2v13.8c0 12.9 7 25 20.2 25h90.4c-13.5 0-20.2-10.4-20.2-25z" fill="#F9FAFD" />
      <path d="M95.4 132H5.6c3.3 6.1 8.9 10.3 16.7 10.3h90.3c-8.3 0-14-3.9-17.2-10.3z" fill="#F2F4FA" />
      <path d="M89.4 103.5v15.3c0 11.4 4.1 20.2 12.3 23.5h11c-13.6 0-20.3-10.4-20.3-25v-13.8h-3z" fill="#fff" />
      <path
        d="M112.4 142.3h1-1zM92.2 117.3v-13.8H2v13.8c0 12.9 7 25 20.2 25h90.2c-13.5 0-20.2-10.4-20.2-25z"
        stroke="#A5A8BA"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <path
        d="M54.6 46.6a2.9 2.9 0 1 0 0-5.7 2.9 2.9 0 0 0 0 5.7zM54.6 30.5a2.9 2.9 0 1 0 0-5.7 2.9 2.9 0 0 0 0 5.7zM60.4 14.5c1.5-.2 2.7-1 2.6-2-.1-1-1.4-1.7-3-1.6-1.5.2-2.6 1-2.5 2 0 1 1.4 1.7 2.9 1.6zM54.6 63.4a2.9 2.9 0 1 0 0-5.8 2.9 2.9 0 0 0 0 5.8zM54.6 79.5a2.9 2.9 0 1 0 0-5.8 2.9 2.9 0 0 0 0 5.8zM54.6 95.6a2.9 2.9 0 1 0 0-5.8 2.9 2.9 0 0 0 0 5.8zM90 26H63v4h27v-4zM68 11.5c-1.8.7-2.1 3-2.1 3h54.7s0-1.9 1-3H68zM90 42H63v4h27v-4zM121 58H63v4h58v-4zM121 74H63v4h58v-4zM120.6 90.5h-58v4h58v-4z"
        fill="#E0E5F0"
      />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M109 48a13 13 0 1 0 0-26 13 13 0 0 0 0 26z" fill="#00BC66" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M111.9 32.3l-4.3 4-1.4-1.4a1.3 1.3 0 1 0-1.8 1.8l2.2 2.3h.1l.1.1h.1l.1.1h.1l.1.1H108.2v-.1h.1l.1-.1h.1l5.2-4.9a1.3 1.3 0 0 0-1.7-1.9z"
        fill="#fff"
      />
    </svg>

    <svg
      *ngIf="image === 'bank-dashboard'"
      width="174"
      height="175"
      viewBox="0 0 174 175"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M85.8234 86.5109H2.68555C2.68555 64.4614 11.4447 43.315 27.0361 27.7236C42.6275 12.1322 63.7739 3.37305 85.8234 3.37305V86.5109Z"
        fill="#E0E5F0"
      />
      <path
        d="M84.3193 86.6406H167.457C167.452 108.686 158.69 129.827 143.099 145.414C127.508 161.001 106.365 169.757 84.3193 169.757V86.6406Z"
        fill="#F2F4FA"
      />
      <path
        d="M86 87.1377V3.9998C108.046 4.0055 129.187 12.7672 144.773 28.3579C160.36 43.9487 169.116 65.0919 169.116 87.1377H86Z"
        fill="white"
      />
      <path
        d="M86.1162 86V169.138C64.0704 169.132 42.9295 160.371 27.3427 144.78C11.756 129.189 2.99981 108.046 2.99981 86H86.1162Z"
        fill="white"
      />
      <path
        d="M85.8234 168.961C131.739 168.961 168.961 131.739 168.961 85.8234C168.961 39.9076 131.739 2.68555 85.8234 2.68555C39.9076 2.68555 2.68555 39.9076 2.68555 85.8234C2.68555 131.739 39.9076 168.961 85.8234 168.961Z"
        stroke="#A5A8BA"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M31.7163 6.9834H18.1787V74.8647H31.7163V6.9834Z"
        fill="white"
        stroke="#A5A8BA"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M45.2534 15.0205H31.7158V74.8437H45.2534V15.0205Z"
        fill="white"
        stroke="#A5A8BA"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M58.7905 30.9854H45.2529V74.8643H58.7905V30.9854Z"
        fill="white"
        stroke="#A5A8BA"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M72.3501 17.5986H58.8125V74.8647H72.3501V17.5986Z"
        fill="white"
        stroke="#A5A8BA"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M69.2987 107.376L37.2598 138.491"
        stroke="#A5A8BA"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M85.8242 2.68555V168.961"
        stroke="#A5A8BA"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.68555 85.8242H168.961"
        stroke="#A5A8BA"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M41.2139 118.077C44.4538 118.077 47.0802 115.451 47.0802 112.211C47.0802 108.971 44.4538 106.345 41.2139 106.345C37.9741 106.345 35.3477 108.971 35.3477 112.211C35.3477 115.451 37.9741 118.077 41.2139 118.077Z"
        stroke="#A5A8BA"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M63.6905 140.533C66.9304 140.533 69.5568 137.907 69.5568 134.667C69.5568 131.427 66.9304 128.801 63.6905 128.801C60.4506 128.801 57.8242 131.427 57.8242 134.667C57.8242 137.907 60.4506 140.533 63.6905 140.533Z"
        stroke="#A5A8BA"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M137.052 172.314C155.506 172.314 170.466 157.354 170.466 138.9C170.466 120.445 155.506 105.485 137.052 105.485C118.598 105.485 103.638 120.445 103.638 138.9C103.638 157.354 118.598 172.314 137.052 172.314Z"
        fill="white"
        stroke="#A5A8BA"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M137.051 140.296C135.385 140.296 133.757 139.802 132.372 138.876C130.986 137.951 129.907 136.635 129.269 135.096C128.632 133.557 128.465 131.863 128.79 130.229C129.115 128.595 129.917 127.094 131.095 125.916C132.273 124.738 133.774 123.936 135.408 123.611C137.042 123.286 138.736 123.453 140.275 124.09C141.814 124.728 143.13 125.808 144.055 127.193C144.981 128.578 145.475 130.207 145.475 131.873"
        stroke="#A5A8BA"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M137.051 140.296C138.717 140.296 140.346 140.79 141.731 141.715C143.116 142.641 144.196 143.957 144.833 145.496C145.471 147.035 145.638 148.729 145.313 150.363C144.988 151.997 144.186 153.497 143.008 154.675C141.829 155.854 140.329 156.656 138.695 156.981C137.061 157.306 135.367 157.139 133.828 156.501C132.289 155.864 130.973 154.784 130.048 153.399C129.122 152.014 128.628 150.385 128.628 148.719"
        stroke="#A5A8BA"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M137.052 123.45V118.057"
        stroke="#A5A8BA"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M137.052 162.515V157.143"
        stroke="#A5A8BA"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M116.918 143.777C118.71 143.777 120.162 142.324 120.162 140.532C120.162 138.74 118.71 137.287 116.918 137.287C115.126 137.287 113.673 138.74 113.673 140.532C113.673 142.324 115.126 143.777 116.918 143.777Z"
        fill="#E0E5F0"
      />
      <path
        d="M156.927 143.777C158.719 143.777 160.172 142.324 160.172 140.532C160.172 138.74 158.719 137.287 156.927 137.287C155.135 137.287 153.683 138.74 153.683 140.532C153.683 142.324 155.135 143.777 156.927 143.777Z"
        fill="#E0E5F0"
      />
      <path
        d="M145.475 27.9131L85.8242 86.6404"
        stroke="#A5A8BA"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M164.514 58.8984L137.159 85.8232"
        stroke="#A5A8BA"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M113.5 9.08984L86.1455 36.0146"
        stroke="#A5A8BA"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      *ngIf="image === 'bank-dd'"
      width="126"
      height="126"
      viewBox="0 0 126 126"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M116.605 109.4H114.762V107.559C114.764 105.919 114.22 104.325 113.216 103.028C112.213 101.73 110.806 100.803 109.218 100.391V51.5328C110.8 51.1253 112.203 50.205 113.206 48.9159C114.209 47.6268 114.757 46.0416 114.762 44.4086V42.5595H122.149C122.55 42.558 122.939 42.4267 123.258 42.1856C123.577 41.9444 123.81 41.6063 123.921 41.2219C124.031 40.8374 124.014 40.4275 123.872 40.0536C123.73 39.6797 123.47 39.3618 123.132 39.1479L63.9825 2.28005C63.6888 2.09706 63.3496 2 63.0035 2C62.6574 2 62.3182 2.09706 62.0245 2.28005L2.86784 39.1479C2.5296 39.3618 2.2699 39.6797 2.12772 40.0536C1.98553 40.4275 1.96852 40.8374 2.07923 41.2219C2.18995 41.6063 2.42241 41.9444 2.74176 42.1856C3.06111 42.4267 3.45013 42.558 3.85043 42.5595H11.2378V44.4086C11.2433 46.0416 11.7904 47.6268 12.7936 48.9159C13.7968 50.205 15.1995 51.1253 16.782 51.5328V100.442C15.1936 100.853 13.787 101.78 12.7835 103.078C11.7799 104.375 11.2362 105.969 11.2378 107.609V109.451H9.39458C7.434 109.453 5.55426 110.232 4.16791 111.617C2.78157 113.002 2.0019 114.881 2 116.84V122.158C2 122.401 2.0479 122.641 2.14098 122.865C2.23406 123.088 2.37048 123.292 2.54241 123.463C2.71433 123.634 2.91837 123.77 3.14284 123.862C3.3673 123.954 3.60777 124.001 3.85043 124H122.149C122.392 124.001 122.633 123.954 122.857 123.862C123.081 123.77 123.286 123.634 123.457 123.463C123.629 123.292 123.766 123.088 123.859 122.865C123.952 122.641 124 122.401 124 122.158V116.84C124.006 115.866 123.819 114.9 123.45 113.998C123.081 113.096 122.537 112.276 121.85 111.585C121.163 110.893 120.346 110.345 119.446 109.97C118.546 109.595 117.58 109.401 116.605 109.4ZM111.068 107.559V109.4H88.8846V107.559C88.8846 106.579 89.2735 105.639 89.966 104.946C90.6585 104.253 91.598 103.862 92.5783 103.86H107.367C108.348 103.862 109.289 104.252 109.982 104.946C110.676 105.639 111.066 106.578 111.068 107.559ZM35.272 100.391V51.5328C36.8545 51.1253 38.2572 50.205 39.2604 48.9159C40.2636 47.6268 40.8107 46.0416 40.8162 44.4086V42.5595H48.2108V44.4086C48.2162 46.0416 48.7633 47.6268 49.7665 48.9159C50.7697 50.205 52.1724 51.1253 53.7549 51.5328V100.442C52.1665 100.853 50.7599 101.78 49.7564 103.078C48.7528 104.375 48.2091 105.969 48.2108 107.609V109.451H40.8162V107.609C40.8178 105.969 40.2741 104.375 39.2705 103.078C38.267 101.78 36.8604 100.853 35.272 100.442V100.391ZM31.5711 51.798V100.133H20.4829V51.798H31.5711ZM57.4558 51.798H68.5441V100.133H57.4558V51.798ZM70.3658 48.0997H55.6053C54.6263 48.0978 53.6879 47.7084 52.9956 47.0166C52.3033 46.3248 51.9135 45.3869 51.9116 44.4086V42.5595H74.0882V44.4086C74.0901 44.8949 73.996 45.3767 73.8113 45.8266C73.6266 46.2765 73.3549 46.6856 73.0118 47.0304C72.6688 47.3752 72.261 47.6491 71.8119 47.8363C71.3628 48.0234 70.8811 48.1203 70.3945 48.1212L70.3658 48.0997ZM51.9045 107.559C51.9045 106.579 52.2934 105.639 52.9859 104.946C53.6784 104.253 54.6179 103.862 55.5982 103.86H70.3874C71.3676 103.862 72.3071 104.253 72.9996 104.946C73.6921 105.639 74.081 106.579 74.081 107.559V109.4H51.9045V107.559ZM72.2378 100.391V51.5328C73.8203 51.1253 75.2229 50.205 76.2261 48.9159C77.2293 47.6268 77.7765 46.0416 77.7819 44.4086V42.5595H85.1837V44.4086C85.1883 46.0429 85.736 47.6294 86.7408 48.9189C87.7456 50.2083 89.1506 51.1278 90.735 51.5328V100.442C89.1446 100.851 87.7358 101.777 86.7307 103.075C85.7255 104.373 85.1812 105.968 85.1837 107.609V109.451H77.7891V107.609C77.7907 105.969 77.247 104.375 76.2435 103.078C75.2399 101.78 73.8334 100.853 72.2449 100.442L72.2378 100.391ZM94.4215 100.133V51.798H105.51V100.133H94.4215ZM111.061 44.4086C111.059 45.3882 110.668 46.327 109.975 47.019C109.281 47.711 108.341 48.0997 107.36 48.0997H92.5783C91.5992 48.0978 90.6608 47.7084 89.9685 47.0166C89.2762 46.3248 88.8865 45.3869 88.8846 44.4086V42.5595H111.068L111.061 44.4086ZM13.0811 38.8684H10.3054L62.9999 6.02847L115.694 38.8684H13.0883H13.0811ZM14.9316 44.4086V42.5595H37.1081V44.4086C37.1062 45.3869 36.7165 46.3248 36.0242 47.0166C35.3319 47.7084 34.3935 48.0978 33.4144 48.0997H18.6324C17.6595 48.0979 16.7265 47.7133 16.0352 47.0293C15.344 46.3452 14.95 45.4166 14.9387 44.4445L14.9316 44.4086ZM14.9316 107.523C14.9316 106.543 15.3205 105.604 16.013 104.91C16.7055 104.217 17.645 103.826 18.6253 103.824H33.4144C34.3947 103.826 35.3342 104.217 36.0267 104.91C36.7192 105.604 37.1081 106.543 37.1081 107.523V109.365H14.9387L14.9316 107.523ZM120.299 120.223H5.6937V116.754C5.6956 115.774 6.08635 114.836 6.7802 114.144C7.47404 113.452 8.41429 113.063 9.39458 113.063H116.605C117.586 113.063 118.526 113.452 119.22 114.144C119.914 114.836 120.304 115.774 120.306 116.754L120.299 120.223Z"
        fill="#00BC66"
        stroke="white"
        stroke-width="2.02"
        stroke-miterlimit="10"
      />
    </svg>

    <h2 data-cy="zero-state.component.headerText">{{ headerText }}</h2>
    <p data-cy="zero-state.component.subText">{{ subText }}</p>
    <gcv-button
      *ngIf="button"
      (clickEvent)="handleButtonClicked()"
      [buttonText]="button.text"
      [type]="button.type"
    ></gcv-button>
  </div>
</div>
